module.exports = __webpack_public_path__ + "img/phone.89a4ea4e.svg";